import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'

Vue.config.productionTip = false

export default Vue
